// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --radio-input-invalid-focus-outline-color: var(--color-red-2);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/RadioInput.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D","sourcesContent":[".commutably {\n  --radio-input-invalid-focus-outline-color: var(--color-red-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
